export default __webpack_public_path__ + "static/2-1504482286141cf5df1124babdd3f4cd.webp";